import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../../atomic/text/Text';
import { sequenceMap } from './candlePatternMap';

export const CandlePatternSequenceBox = ({ sequence, index, length }) => {
  const label = sequenceMap[sequence.candleSequence];
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          width: '35px',
          border: '1px solid white',
          backgroundColor: colors.black,
          height: 'fit-content',
          textAlign: 'center',
          marginBottom: '3px',
        }}
      >
        <Body3 color={colors.lightGrey} fontWeight={700}>
          {label}
        </Body3>
      </div>
      {length > 1 && index !== length - 1 && ((index + 1) % 4 !== 0) ? (
        <Body3 color={colors.lightGrey} fontWeight={700}>
          -
        </Body3>
      ) : null}
    </div>
  );
};

CandlePatternSequenceBox.propTypes = {
  index: PropTypes.number,
  length: PropTypes.number,
  sequence: PropTypes.shape({
    candleSequence: PropTypes.any
  })
};


